import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { isChunkLoadError, reloadOnceForNewVersion } from '@/shared/lib/chunkRecovery';
import { Button } from '@/shared/ui/atoms/Button';
import { EmptyState } from '@/shared/ui/molecules/EmptyState';

/** Route-level error screen. A stale chunk after a deploy reloads once into the new version. */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation(undefined, { keyPrefix: 'common' });
  const stale = isChunkLoadError(error);

  useEffect(() => {
    if (stale) reloadOnceForNewVersion();
  }, [stale]);

  return (
    <EmptyState
      title={stale ? t('newVersionTitle') : t('crashTitle')}
      hint={stale ? t('newVersionBody') : t('crashBody')}
      action={<Button onClick={() => window.location.reload()}>{t('reload')}</Button>}
    />
  );
}
